import * as types from "./mutations-types";

export const setAuthErrorHandled = ({ commit }, payload) => {
    commit(types.SET_IS_AUTH_ERROR_HANDLED, payload)
}